const dnsCheckCache = new Map();

export const getCachedDnsCheck = email => {
  return dnsCheckCache.get(email);
};

export const setCachedDnsCheck = (email, result) => {
  return dnsCheckCache.set(email, result);
};
